(() => {
  /* The offer tiles of the Avalon collection page (21 Oct 2026): for two, three and four editions and the whole
     archive, what Shopify charges today for that many editions, and what that is per edition. The archive tile also
     says what it saves, and its button puts every edition not yet in the cart in it (assets/avalon-archive-offer.js).
     The numbers are Shopify's own answer (assets/avalon-live-pricing.js); none is written in the theme. */
  const strip = (text) => String(text).replace(/[.,]00(?=\D*$)/, '');
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const init = () => document.querySelectorAll('[data-collection-offer]:not([data-collection-ready])').forEach((el) => {
    el.dataset.collectionReady = 'true';
    let lines = [];
    try {
      lines = JSON.parse(el.querySelector('[data-collection-lines]').textContent);
    } catch (error) {
      return;
    }
    const priceEl = el.querySelector('[data-collection-price]');
    const eachEl = el.querySelector('[data-collection-each]');
    const whisper = el.querySelector('[data-collection-whisper]');
    const take = el.querySelector('[data-collection-take]');
    const status = el.querySelector('[data-collection-status]');
    if (take) {
      take.addEventListener('click', async () => {
        if (take.disabled) return;
        const label = take.textContent;
        take.disabled = true;
        take.textContent = 'One moment…';
        if (status) status.textContent = '';
        try {
          if (window.AvalonArchive) {
            await window.AvalonArchive.take(el, { kind: 'tile', placement: 'collection', editions: lines.map((line) => ({ id: line.id })) }, false);
          } else {
            const res = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: lines }) });
            if (!res.ok) throw new Error('Please check your selection in cart.');
            window.location.assign(`${root}cart`);
          }
        } catch (error) {
          take.disabled = false;
          take.textContent = label;
          if (status) status.textContent = (error && error.said) || 'Something went wrong. Please try again.';
        }
      });
    }
    let started = false;
    const price = async () => {
      if (started) return;
      started = true;
      observer.disconnect();
      try {
        const api = window.AvalonLivePricing;
        /* Drawn as Liquid draws prices (the tile hands over one amount Liquid formatted), else the browser's format. */
        const money = (api.moneyLike && api.moneyLike(el.dataset.moneySample)) || ((amount, currency) => strip(api.money(amount, currency)));
        const q = await api.quote(lines, el.dataset.country, el.dataset.currency);
        const count = lines.reduce((n, line) => n + line.quantity, 0);
        /* Outside the dollar, rounded as Shopify rounds that currency's single prices (27 Oct 2026): the total up,
           the saving down, an "about" figure to the nearest unit. The cart charges the exact total, never more. */
        const r = q.rounding || { on: false, unit: 0, up: (x) => x, upTo: (x) => x, down: (x) => x, near: (x) => Math.round(x), fits: () => true };
        /* Never above the same editions at their single prices. */
        const total = r.upTo(q.total, q.original);
        const saved = r.down(Math.max(0, q.original - total));
        priceEl.textContent = money(total, q.currency);
        const cents = Math.round((total * 100) / count);
        const even = r.on ? cents * count === Math.round(total * 100) && r.fits(cents / 100) : cents % 100 === 0;
        eachEl.textContent = even
          ? `${money(cents / 100, q.currency)} each`
          : `about ${money(r.on ? r.near(total / count) : Math.round(total / count), q.currency)} each`;
        if (whisper && saved > 0.005) {
          whisper.textContent = `saves ${money(saved, q.currency)}, but that is not the point.`;
          whisper.hidden = false;
        }
      } catch (error) {
        /* No answer from Shopify: the tile keeps its count, and the cart prices the selection. */
        priceEl.textContent = '';
        eachEl.textContent = 'priced in your cart';
      }
    };
    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) price();
    }, { rootMargin: '200px' });
    observer.observe(el);
    /* A page drawn in the background never says what is on screen: tiles within two screens ask anyway. */
    setTimeout(() => {
      if (!started && el.getBoundingClientRect().top < (window.innerHeight || 800) * 2) price();
    }, 4000);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
